import { createListenerMiddleware, ListenerEffectAPI } from '@reduxjs/toolkit'
import { ActivityPartAxis } from '@/api/models/aggregate'
import { isTileView } from '@/features/activity/helpers/isTileView'
import { isAvailable } from '@/hooks/useActivityParts/helpers/isAvailable'
import { objectiveWorkflowApi } from '@/store/api/objectiveWorkflowApi'
import { AggregateState, setActiveActivityPartAxis } from '@/store/slices/aggregateSlice'
import { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'
import { findActiveActivityPart } from './utils/findActiveActivityPart'

export const aggregateListenerMiddleware = createListenerMiddleware()

aggregateListenerMiddleware.startListening({
  matcher: objectiveWorkflowApi.endpoints.fetchActivityWorkflowAggregateFullTree.matchFulfilled,
  effect: async (action, listenerApi: ListenerEffectAPI<any, any>) => {
    const dispatch = listenerApi.dispatch

    const aggregateSlice: AggregateState = listenerApi.getState().aggregate
    const objectiveWorkflowAggregateId = aggregateSlice.current?.id

    const activeActivityPartAxis = aggregateSlice.activeActivityPartAxis

    if (activeActivityPartAxis) {
      return
    }

    if (!objectiveWorkflowAggregateId) {
      return
    }

    const activitiesWithAggregates = aggregateSlice.activitiesWithAggregates

    if (!activitiesWithAggregates) {
      throw Error('activitiesWithAggregates should be defined at this step')
    }

    // if root activity is tile and activity not started, then we need to stay on root activity
    if (isTileView(activitiesWithAggregates)) {
      return
    }

    const activeActivityPart = findActiveActivityPart(activitiesWithAggregates, true)

    if (!activeActivityPart) {
      // if we don't have active activity part, we need to set first available activity part to redirect to it
      // otherwise we will see empty screen
      if (isAllNotAvailable(activitiesWithAggregates) && activitiesWithAggregates.children.length > 0) {
        console.log('[aggregateListenerMiddleware] All activities are not available')
        dispatch(setActiveActivityPartAxis(activitiesWithAggregates.children[0].id as ActivityPartAxis))
      }

      return
    }

    dispatch(setActiveActivityPartAxis(activeActivityPart.axis))
  },
})

function isAllNotAvailable(activitiesWithAggregates: FrontActivityWithAggregate): boolean {
  return (activitiesWithAggregates.children || []).every((activityPart) => {
    return !isAvailable(activityPart)
  })
}
